import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import DateInput from "@/components/DateInput";
import FirmSelect from "@/components/FirmSelect";
import { Plus } from "lucide-react";

let catalogCache = null;
export const useCatalog = () => {
  const [cat, setCat] = useState(catalogCache || []);
  useEffect(() => { if (!catalogCache) api.get("/deductions/catalog").then(r => { catalogCache = r.data; setCat(r.data); }); }, []);
  return cat;
};

export default function DeductionForm({ firms, firmId, onCreated, compact }) {
  const catalog = useCatalog().filter(c => c.type !== "percent");
  const [f, setF] = useState({ firm_id: firmId || "", category: "", name: "", period: "", amount: "", notes: "" });
  const [busy, setBusy] = useState(false);
  const items = catalog.find(c => c.category === f.category)?.items || [];

  const save = async () => {
    if (!f.category || !(Number(f.amount) > 0)) { toast.error("Kesinti grubu ve tutar zorunlu"); return; }
    setBusy(true);
    try {
      const r = await api.post("/deductions", { ...f, firm_id: (firmId ?? f.firm_id) || null, name: f.name || f.category, amount: Number(f.amount), period: f.period || null });
      toast.success("Kesinti eklendi");
      setF({ ...f, name: "", period: "", amount: "", notes: "" });
      onCreated?.(r.data);
    } catch (e) { toast.error(e.response?.data?.detail || "Eklenemedi"); }
    finally { setBusy(false); }
  };

  return (
    <div className={`grid gap-3 ${compact ? "grid-cols-[1.2fr_1.4fr_140px_120px_auto]" : "grid-cols-2"} items-end`} data-testid="deduction-form">
      {!compact && <div className="col-span-2"><Label>Firma</Label><FirmSelect firms={firms} value={f.firm_id} onChange={v => setF({ ...f, firm_id: v })} testid="ded-form-firm" allLabel="Firma seçin" /></div>}
      <div><Label className="text-xs">Kesinti Grubu</Label>
        <Select value={f.category} onValueChange={v => setF({ ...f, category: v, name: "" })}>
          <SelectTrigger data-testid="ded-form-category"><SelectValue placeholder="Grup seçin" /></SelectTrigger>
          <SelectContent>{catalog.map(c => <SelectItem key={c.category} value={c.category}>{c.category}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div><Label className="text-xs">Kesinti Kalemi</Label>
        <Input list={`ded-items-${f.category}`} value={f.name} onChange={e => setF({ ...f, name: e.target.value })} placeholder={items[0] || "Kalem adı"} data-testid="ded-form-name" />
        <datalist id={`ded-items-${f.category}`}>{items.map(i => <option key={i} value={i} />)}</datalist>
      </div>
      <div><Label className="text-xs">Dönem</Label><DateInput value={f.period} onChange={e => setF({ ...f, period: e.target.value })} data-testid="ded-form-period" /></div>
      <div><Label className="text-xs">Tutar (TL)</Label><Input type="number" step="0.01" value={f.amount} onChange={e => setF({ ...f, amount: e.target.value })} data-testid="ded-form-amount" /></div>
      {!compact && <div className="col-span-2"><Label>Not</Label><Input value={f.notes} onChange={e => setF({ ...f, notes: e.target.value })} /></div>}
      <Button onClick={save} disabled={busy} className={`bg-amber-500 hover:bg-amber-600 text-slate-950 ${compact ? "" : "col-span-2"}`} data-testid="ded-form-save">
        <Plus className="w-4 h-4 mr-1" /> Ekle
      </Button>
    </div>
  );
}
